import { render } from "./InputSelect.vue?vue&type=template&id=1fc6f20d&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=1fc6f20d&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc6f20d"]])

export default __exports__